
export function getDateDiff(examined) {
    var now = Date.now();
    var datediff;
    if (Array.isArray(examined)) {
      examined.sort((a, b) => b.timestamp - a.timestamp); //sort descending
      datediff = (now - examined[0].timestamp) / (24 * 3600 * 1000);
    }
    else {
      datediff = (now - examined) / (24 * 3600 * 1000);
    }
    return datediff
  }



export function getExamExpiry(examined) {
    if (isNaN(examined)) return "Nieprzebadano";
    var datediff = getDateDiff(examined);
    var monthsago = Math.round(datediff / 30);
    if (monthsago == 0) return "Świeże wyniki badań";
    if (monthsago == 1) return "Przebadano 1 miesiąc temu";
    var m100=monthsago % 100;
    var md=Math.floor(m100/10)
    var m10=m100 % 10;

    if ((m10>=2) && (m10<=4) && (md!=1)) { return "Przebadano " + monthsago + " miesiące temu"; }
      else { return "Przebadano " + monthsago + " miesięcy temu"; }
  }



export function getExamTime(examined) {
    var datediff = getDateDiff(examined);
    return datediff;
  }


export function getExamValue(examined) {
    if ((!examined) || (isNaN(examined))) return 0;
    var days = getExamTime(examined);
    var years = 1 + Math.floor(days / 365);
    if (years > 6) years = 6;
    return years;
  }
